import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import * as EventTicketsActions from 'libs/gb-front/event-tickets/data-access/src/lib/+state/event-tickets.actions'
import { EventTicketsFacade } from 'libs/gb-front/event-tickets/data-access/src/lib/+state/event-tickets.facade'

@Component({
  selector: 'gb-event-ticket-mismatch-dialog',
  templateUrl: './gb-event-ticket-mismatch-dialog.component.html',
  styleUrls: ['./gb-event-ticket-mismatch-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class GbEventTicketMismatchDialogComponent {
  selectedEventTicket$ = this.eventTicketsFacade.selectedEventTicket$

  get token(): string {
    return this.route.snapshot.queryParams['token']
  }

  constructor(private eventTicketsFacade: EventTicketsFacade, private route: ActivatedRoute) {}

  onAssignToMe(): void {
    this.eventTicketsFacade.dispatch(EventTicketsActions.acceptEventTicketInvite({ token: this.token }))
  }

  onAcceptOnBehalf(): void {
    this.eventTicketsFacade.dispatch(EventTicketsActions.openEventTicketAcceptDialog())
  }
}
